export default function() {
  return (Math.random() - 0.5) * 1e-6;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-force/src/jiggle.js
// module id = HYZs
// module chunks = 0